import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Typography, Statistic, List } from 'antd';
import { TeamOutlined, BarsOutlined, ProjectOutlined, BellOutlined, CalendarOutlined } from '@ant-design/icons';
import { useAuth } from "./Context";
import ProximosEventos from './agenda/ProximosEventos';
import { useNavigate } from 'react-router-dom';
import { getEventosPorUsuario } from '../servicios/agenda/servicios';
import dayjs from 'dayjs';

const { Title } = Typography;

const Bienvenida = () => {
  const { currentUser, permisos, sucursal, token } = useAuth();
  const navigate = useNavigate();
  const [proximosEventos, setProximosEventos] = useState(0);
  
  useEffect(() => {
    const cargarEventos = async () => {
      if (!currentUser?.uid || !sucursal || !token) return;
      
      try {
        // Obtenemos los periodos relevantes (mes actual y el siguiente)
        const hoy = dayjs();
        const periodoActual = `${hoy.year()}-${(hoy.month() + 1) < 10 ? '0' + (hoy.month() + 1) : hoy.month() + 1}`;
        
        const mesSiguiente = hoy.add(1, 'month');
        const periodoSiguiente = `${mesSiguiente.year()}-${(mesSiguiente.month() + 1) < 10 ? '0' + (mesSiguiente.month() + 1) : mesSiguiente.month() + 1}`;
        
        // Obtener eventos del usuario actual para ambos periodos
        const [eventosActual, eventosSiguiente] = await Promise.all([
          getEventosPorUsuario(currentUser.uid, sucursal, token, periodoActual),
          getEventosPorUsuario(currentUser.uid, sucursal, token, periodoSiguiente)
        ]);
        
        // Combinamos todos los eventos
        const todosEventos = [...eventosActual, ...eventosSiguiente];
        
        // Filtrar solo los próximos eventos (de hoy en adelante)
        const fechaHoy = dayjs().format('YYYY-MM-DD');
        const proximosEventosCount = todosEventos.filter(evento => evento.fecha >= fechaHoy).length;
        setProximosEventos(proximosEventosCount);
      } catch (error) {
        console.error("Error al cargar conteo de eventos:", error);
      }
    };
    
    cargarEventos();
  }, [currentUser, sucursal, token]);

  // Datos para el panel de bienvenida
  const panelData = {
    tareasPendientes: 5,
    proyectosActivos: 3,
    notificaciones: 2,
    proximasReuniones: proximosEventos
  };
  
  return (
    <>
      <Title level={2} style={{ marginBottom: 24, textAlign: 'center' }}>
        Bienvenido, {currentUser?.displayName || 'Usuario'}
      </Title>
      
      <Row gutter={[16, 16]}>
        {/* Tarjetas con estadísticas rápidas */}
        <Col xs={24} sm={12} md={6}>
          <Card style={{ textAlign: 'center' }}>
            <BarsOutlined style={{ fontSize: 24, color: '#1890ff' }} />
            <Statistic title="Tareas Pendientes" value={panelData.tareasPendientes} />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} md={6}>
          <Card style={{ textAlign: 'center' }}>
            <ProjectOutlined style={{ fontSize: 24, color: '#52c41a' }} />
            <Statistic title="Proyectos Activos" value={panelData.proyectosActivos} />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} md={6}>
          <Card 
            style={{ textAlign: 'center', cursor: 'pointer' }} 
            onClick={() => navigate('/sistema/agenda')}
            hoverable
          >
            <CalendarOutlined style={{ fontSize: 24, color: '#faad14' }} />
            <Statistic title="Próximas Reuniones" value={panelData.proximasReuniones} />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} md={6}>
          <Card style={{ textAlign: 'center' }}>
            <BellOutlined style={{ fontSize: 24, color: '#f5222d' }} />
            <Statistic title="Notificaciones" value={panelData.notificaciones} />
          </Card>
        </Col>
        
        {/* Próximos eventos */}
        <Col xs={24} md={12}>
          <ProximosEventos />
        </Col>
        
        {/* Actividad reciente */}
        <Col xs={24} md={12}>
          <Card 
            title={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <BarsOutlined style={{ marginRight: 8, color: '#52c41a' }} /> 
                <span>Actividad Reciente</span>
              </div>
            }
            style={{ height: '100%' }}
          >
            <List
              itemLayout="horizontal"
              dataSource={[
                { title: "Cotización actualizada", time: "Hace 2 horas", user: "Carlos Mendez" },
                { title: "Empleado agregado", time: "Hace 5 horas", user: "Ana López" },
                { title: "Cliente nuevo registrado", time: "Ayer", user: "José Pérez" },
                { title: "Proyecto completado", time: "Hace 2 días", user: "María González" }
              ]}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={item.title}
                    description={`${item.time} por ${item.user}`}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Bienvenida;
